import {
    SetClientNewNotificationsStateHandler
} from '../../gameClient/clientCommands/SetClientNewNotificationsStateHandler';
import { GameClient } from '../../gameClient/gameClient';
import { NotificationsWrap } from '../../general/modules/fcm/NotificationsWrap';
import { WebpushServiceApi } from '../../general/modules/fcm/WebpushServiceApi';

type TrySetNewWebPushSaveDataType = {
    isAccessPush: boolean
}

export class SetNotificationsStateHandler {
    // eslint-disable-next-line class-methods-use-this
    public handle(request: TrySetNewWebPushSaveDataType): void {
        this.setNotificationState(request.isAccessPush);
    }

    private async setNotificationState(state: boolean): Promise<void> {
        try {
            let completed: boolean;
            if (state) {
                if (!NotificationsWrap.isSupported()) {
                    console.error('Browser has disabled web-push notifications');
                    GameClient.getInstance().sendCommand(new SetClientNewNotificationsStateHandler({
                        isSuccess: false
                    }));
                    return;
                }

                const hasRegisterDate = await WebpushServiceApi.getPushSubscriptionState();
                if (!hasRegisterDate) {
                    await WebpushServiceApi.saveUserToken('leanplum');
                } else {
                    await WebpushServiceApi.setAccountStateInWebpushService(state);
                }

                completed = await NotificationsWrap.registerForLeanplum();
            } else {
                completed = await NotificationsWrap.unregisterFromWebPush();
            }
            GameClient.getInstance().sendCommand(new SetClientNewNotificationsStateHandler({
                isSuccess: completed
            }));
        } catch (exception) {
            GameClient.getInstance().sendCommand(new SetClientNewNotificationsStateHandler({
                isSuccess: false
            }));
            console.error('Leanplum fault on setNotificationState', exception);
            window.Sentry.captureException(exception);
        }
    }
}
